"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileButton = FileButton;
var _material = require("@mui/material");
var _CloseIcon = _interopRequireDefault(require("mdi-react/CloseIcon"));
var _react = require("react");
var _mui = require("tss-react/mui");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useStyles = (0, _mui.makeStyles)()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),
    alignItems: 'center'
  },
  fileLink: {
    color: theme.palette.grey[900]
  },
  deleteButton: {
    cursor: 'pointer',
    opacity: 0.7,
    '&:hover': {
      opacity: 1
    }
  }
}));
function FileButton({
  accept,
  buttonTestId,
  children,
  disabled = false,
  showDelete = false,
  deleteButtonTestId,
  deleteLabel,
  fileInputTestId,
  fileName,
  fileUrl,
  onChange,
  previewTestId
}) {
  const {
    classes
  } = useStyles();
  const inputRef = (0, _react.useRef)(null);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: classes.root,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Button, {
      component: "label",
      variant: "contained",
      disabled: disabled,
      "data-testid": buttonTestId,
      onClick: () => {
        if (inputRef.current) {
          // workaround for a chromium bug where selecting the same file twice does not trigger the input's onChange event, even if the file has changed
          inputRef.current.value = '';
        }
      },
      children: [children, /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
        ref: inputRef,
        type: "file",
        hidden: true,
        accept: accept,
        onChange: event => onChange(event.target.files?.[0]),
        "data-testid": fileInputTestId
      })]
    }), fileUrl && fileName && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Link, {
        href: fileUrl,
        className: classes.fileLink,
        "data-testid": previewTestId,
        rel: "noreferrer",
        children: fileName
      }), showDelete && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Tooltip, {
        title: deleteLabel,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.IconButton, {
          "data-testid": deleteButtonTestId,
          "aria-label": deleteLabel,
          className: classes.deleteButton,
          disabled: disabled,
          onClick: () => onChange(undefined),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CloseIcon.default, {})
        })
      })]
    })]
  });
}
//# sourceMappingURL=index.js.map